<template>
  <div class="personal">
    
    <Header titles="收款设置"></Header>
    <div class="tab">
        <div @click="tpage = true" :class="tpage ? 'tpage' : ''">收款账号</div>
        <div @click="tpage = false" :class="!tpage ? 'tpage' : ''">个税资料</div>
    </div>
    <template v-if="tpage">
      <!-- <div class="inmoney">发放拉新红包奖励</div> -->
      <!-- <TitleInput placeholder="支付宝账号" v-model="user.alipay" /> -->
      <div class="bonus">
        <img class="bonus-bag" src="@/assets/image/bonus-bag.png" alt="">
        <span>用于发放任务奖励金</span>
        <img class="bonus-money" src="@/assets/image/bonus-money.png" alt="">
      </div>
      <TitleInput placeholder="真实姓名" v-model="user.realname" />
      
      <ChooseInput placeholder="银行类型" @click.native="chooseBank">{{user.bank_name}}</ChooseInput>
      <ChooseInput placeholder="银行支行" @click.native="chooseBranch">{{user.bank_second_name}}</ChooseInput>
      <TitleInput placeholder="卡号" v-model="user.bank_no" />
    </template>
    <template v-else>
      <div class="bonus">
        <img class="bonus-bag" src="@/assets/image/tax-board.png" alt="">
        <span>用于代扣代缴个税</span>
        <img class="bonus-money" src="@/assets/image/tax-coin.png" alt="">
      </div>
      <div class="trmon">必须提供真实、有效信息，姓名必须与银行账号收款人一致</div>
      <!-- <ChooseInput placeholder="证件类型" @click.native="chooseCer">{{idType}}</ChooseInput> -->
      <TitleInput placeholder="请输入身份证号码" v-model="user.id_card" />
      <ChooseInput placeholder="性别" @click.native="chooseHome">{{user.sex}}</ChooseInput>
      <ChooseInput placeholder="出生日期" @click.native="chooseDay">{{user.birthday}}</ChooseInput>
      <div class="per-box">
        <div class="per-title">身份证图片</div>
        <div class="per-list">
          <div class="fls">
            <img :src="fileList" class="xx" alt="">
            <Uploader class="sfz-z" :after-read="afterRead" />
            <div>正面</div>
          </div>
          <div class="fls">
            <img :src="fileLists" class="xx" alt="">
            <Uploader class="sfz-z" :after-read="afterReads" />
            <div>反面</div>
          </div>
        </div>
      </div>
    </template>
    <div class="money-get">
      <div class="money-cl" @click="submit()">
        保存
      </div>
    </div>
    <popup v-model="showFlag" position="bottom">
      <Picker
       v-if="!birth"
        title=""
        show-toolbar
        :columns="selectAll"
        @confirm="onConfirm"
      />
      <van-datetime-picker
        v-else
        @confirm="onYear"
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </popup>
    <!-- <template >
      <div class="ev-row">
        <div class="ev-left">姓名：</div>
        <div class="ev-ri">{{realName}}</div>
      </div>
      <div class="ev-row">
        <div class="ev-left">支付宝账户：</div>
        <div class="ev-ri">{{zfbUser}}</div>
      </div>
      <div class="money-get">
        <div class="money-cl" @click="upType = true">
          重新上传
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>
let moment = require("moment")
import Header from '@/components/header.vue'
import { Uploader, Toast, Popup, Picker } from 'vant'
import { upz } from '@/api/api/upload'
import { editUser, getIdcard } from '@/api/api/user'
import TitleInput from '@/components/TitleInput'
import ChooseInput from '@/components/ChooseInput'
import {getUserInfo} from '@/api/api/user'
export default {
  data() {
    return {
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2010, 11, 31),
      currentDate: new Date(),
      choType: 1,
      birth: false,
      tpage: true,
      fileList: '',
      fileLists: '',
      idType: '身份证',
      user: {
        bank_no: '',
        id_card: '',
        alipay: '',
        id_card_type: 1,
        realname: '',
        bank_name: '',
        bank_second_name: '',
        bank_second: '',
        sex: ''
      },
      zfbUser: '',
      idNum: '',
      upType: true,
      showFlag: false,
      selectAll: '',
      selectSex: ['男','女'],
      selectCer: ['身份证'],
    }
  },
  components: {
    Uploader,
    TitleInput,
    ChooseInput,
    Popup,
    Picker,
    Header
  },
  activated() {
    this.user.bank_name = this.$store.state.bank
    this.user.bank_second = this.$store.state.code
    this.user.bank_second_name = this.$store.state.branch
  },
  created () {
    getUserInfo().then(res => {
      console.log(res)
      this.user.bank_no = res.data.data.bank_no
      this.user.bank_second = res.data.data.bank_second
      this.user.bank_second_name = res.data.data.bank_second_name
      this.user.id_card = res.data.data.id_card
      // this.user.alipay = res.data.data.alipay
      this.user.id_card_type = res.data.data.id_card_type
      this.user.realname = res.data.data.realname
      this.user.bank_name = res.data.data.bank_name
      this.user.sex = res.data.data.sex
      this.user.birthday = res.data.data.birthday
      if(res.data.data.bank_name != ''){
        this.$store.commit('SET_BANK', res.data.data.bank_name)
      }
      if (res.data.data.bank_name != ''){
      this.$store.commit('SET_BRANCH', res.data.data.bank_second)
      }
    })
    getIdcard().then(res => {
      this.fileLists =  res.data.data.back
      this.fileList = res.data.data.front
    })
  },
  methods: {
    chooseBank() {
      this.$router.push('bankc')
    },
    chooseBranch() {
      if(!this.user.bank_name || this.user.bank_name == '银行类型') return Toast('请先选择银行类型')
      this.$router.push('/branch')
    },
    chooseDay() {
      this.birth = true
      this.showFlag = true
    },
    onYear(value) {
      this.user.birthday = moment(value).format('YYYY-MM-DD')
      this.showFlag = false
    },
    onConfirm(value, index) {
      if(this.choType === 1) {
        this.user.id_card_type = index+1
        this.idType = value
      } else if(this.choType === 2) {
        this.user.sex = value
      }
      this.showFlag = false
    },
    chooseCer() {
      this.choType = 1
      this.birth = false
      this.selectAll = this.selectCer
      this.showFlag = true
    },
    chooseHome() {
      this.choType = 2
      this.birth = false
      this.selectAll = this.selectSex
      this.showFlag = true
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (file.file.size > 5242880) return Toast('图片不能大于5M')
      const form = new FormData()
      form.append('idCardImg', file.file, file.file.name)
      form.append('side', 'front')
      upz(form).then(res => {
        // console.log(res.data)
        if (res.data.errorCode == 0) {
          getIdcard().then(res => {
            this.fileList = res.data.data.front
          })
        }
      })
    },
    afterReads(file) {
      // 此时可以自行将文件上传至服务器
      if (file.file.size > 5242880) return Toast('图片不能大于5M')
      const form = new FormData()
      form.append('idCardImg', file.file, file.file.name)
      form.append('side', 'back')
      upz(form).then(res => {
        // console.log(res.data)
        if (res.data.errorCode == 0) {
          getIdcard().then(res => {
            this.fileLists =  res.data.data.back
          })
        }
      })
    },
    submit() {
      if (!this.user.realname) return Toast('姓名不能为空')
      // if (!this.user.alipay) return Toast('账号不能为空')
      if (!this.fileList) return Toast('请上传正面')
      if (!this.fileLists) return Toast('请上传反面')
      if(!this.user.id_card) return Toast('身份证号不能为空')
      if(!this.user.sex) return Toast('请选择性别')
      if(!this.user.birthday) return Toast('请选择出生日期')
      if(!this.user.bank_name || this.user.bank_name == '银行类型') return Toast('请选择银行类型')
      if(!this.user.bank_second || this.user.bank_second == '银行支行') return Toast('请选择银行支行')
      editUser(this.user).then( res => {
        if(res.data.errorCode == 0) {
          Toast({
            type: 'fail',
            message: '提交成功',
            duration: 1000
          })
        } else {
          Toast({
            type: 'fail',
            message: res.data.errorMsg,
            duration: 1000
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.personal {
  min-height: 100%;
  padding-top: 90px;
  .input-warp {
    display: block;
    margin: 0 20px;
    margin-top: 16px;
    border-radius: 10px;
    padding-left: 8px;
    line-height: 40px;
    color: rgb(112, 112, 112);
    height: 40px;
    background-color: #f2f2f7;
  }
  .trmon {
    border-top: 1px solid #ccc;
    margin: 0 10%;
    padding: 10px 10px 0px;
    text-align: center;
    font-size: 12px;
  }
  .inmoney {
    padding: 32px  0 12px;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
  .bonus {
    font-size: 20px;
    font-weight: 700;
    margin: 10px 10%;
    height: 60px;
    color: white;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: linear-gradient(177deg, #0286FF 0%, #074FC7 100%);
    &-bag {
      width: 40px;
      height: 45px;
    }
    &-money {
      width: 25px;
      height: 25px;
    }
  }
  .tab {
    z-index: 599;
    background: white;
    position: fixed;
    top: 45px;
    height: 44px;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    div {
      width: 42%;
      border-radius: 4px;
      height: 26px;
      line-height: 28px;
      text-align: center;
      background-color: #B5B5B5;
      color: white;
      border-radius: 4px;
    }
    .tpage {
      background-color: #0286FF;
    }
    .al-back {
      width: 12px;
      height: 21px;
      position: absolute;
      left: 10px;
    }
  }
  .fls {
    position: relative;
  }
  .ev-im {
    padding-top: 20px;
    padding-left: 20px;
    .sfz-z {
      z-index: 999;
      opacity: .5;
      width: 80px;
      height: 80px;
      margin-right: 14px;
    }
  }
  .ev-row {
    display: flex;
    .ev-left {
      padding: 12px 0;
      width: 110px;
      text-align: right;
    }
    .ev-ri {
      padding: 12px 0;
      padding-left: 10px;
    }
  }
  .money-get {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    .money-cl {
      width: 60%;
      background-color: #4464eb;
      color: white;
      text-align: center;
      height: 46px;
      line-height: 46px;

    }
  }
  .per-box {
    padding: 0 15px;
    padding-top: 15px;
    .per-list {
      .xx {
        position: absolute;
        width: 80px;
        height: 80px;
        margin-right: 8px;
        margin-bottom: 8px;
      }
      display: flex;
      color: #999999;
      text-align: center;
    }
    .van-uploader__upload {
      background-color: white;
      z-index: 7;
      // opacity: 0.8;
    }
    .per-inp {
      width: 100%;
      height: 45px;
      border: 1px solid #E8E8E8;
      padding: 0 10px;
      border-radius:4px;
    }
    .per-title {
      margin-bottom: 8px;
      color: #999999;
      font-size: 12px;
    }
  }
  .get-header {
    position: fixed;
    top: 0;
    width: 100%;
  }
}
</style>